import { useSection, useSettings, resolveUrl } from "../lib/useCMS";

const FALLBACK = ["DISCIPLINE", "DETAILS", "HOCKEY IQ", "EDGE WORK", "PUCK CONTROL", "DECISION MAKING", "DEFENSEMEN", "BUILT DIFFERENT"];

export const Ticker = () => {
  const { words = FALLBACK } = useSection("ticker", { words: FALLBACK });
  const list = Array.isArray(words) && words.length ? words : FALLBACK;
  const row = [...list, ...list, ...list];
  return (
    <section id="ticker" data-testid="ticker-section" className="relative border-y border-white/10 bg-brand overflow-hidden">
      <div className="py-5 animate-marquee font-display text-white text-2xl md:text-3xl uppercase tracking-tight">
        {row.map((w, i) => (
          <span key={i} className="ticker-item">
            <span>{w}</span>
            <span className="inline-block h-2 w-2 bg-white rotate-45" />
          </span>
        ))}
      </div>
    </section>
  );
};

export const LogoStrip = () => {
  const settings = useSettings({
    logo_url: "https://customer-assets.emergentagent.com/job_hockey-landing-v2/artifacts/7dc9f10s_Built%20different%20primary%20_PNG.avif",
  });
  const data = useSection("logo_strip", {
    accreditation_label: "Accreditation",
    accreditation_text: "USA Hockey Certified · Precision Nutrition",
    pills: ["On-Ice", "Strength", "Nutrition", "Off Season", "Video Review"],
  });
  const pills = Array.isArray(data.pills) && data.pills.length ? data.pills : ["On-Ice", "Strength", "Nutrition", "Off Season", "Video Review"];
  return (
    <section className="bg-black py-10 border-b border-white/10" data-testid="logo-strip">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 flex flex-col md:flex-row items-center gap-6 md:gap-10 justify-between">
        <div className="flex items-center gap-4">
          <img src={resolveUrl(settings.logo_url)} alt="" role="presentation" loading="lazy" decoding="async" className="h-12 w-12 object-contain" />
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-brand-light font-bold">{data.accreditation_label}</div>
            <div className="text-xs text-zinc-400 mt-1">{data.accreditation_text}</div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-6 md:gap-10 text-[11px] tracking-[0.25em] uppercase text-zinc-400 font-semibold">
          {pills.map((p, i) => (
            <span key={`${p}-${i}`} className="flex items-center gap-6 md:gap-10">
              <span>{p}</span>
              {i < pills.length - 1 && <span className="h-1 w-1 bg-brand-light rotate-45" />}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
